export const MLP_PLATFORM_META_DESCRIPTION_BG =
  "Платформата за медиен мониторинг на Perceptica съчетава алармирания, табла, нагласи и експорт на медийно разузнаване. Заявете демо.";
